export default __webpack_public_path__ + "static/media/file.3bab4e0b.svg";